import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import './PrivacyPolicy.css';

export class PrivacyPolicy extends Component {
  render() {
    console.log(`REACT_APP_PLACEHOLDER1: ${process.env.REACT_APP_PLACEHOLDER1}`);
    return (
      <div className="Regular-page ui stackable center aligned padded column grid">
        <div className="one wide column">
        </div>

        <div className="ten wide column center aligned">
          <Link to="/">
            <button className="ui animated button">
              <div className="visible content">Back</div>
              <div className="hidden content">
                <i aria-hidden="true" className="left arrow icon"></i>
              </div>
            </button>
          </Link>

          <div>
            &nbsp;
          </div>

          <div>
            <p>
              Privacy Policy<br/>
              Last Updated: April 27, 2018
            </p>
          </div>

          <div>
            &nbsp;
          </div>

          <div className="left-aligned">

            Error!

          </div>

        </div>

        <div className="one wide column">
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/PrivacyPolicy.js